export default "__VITE_ASSET__CUCJZivY__"